import Vue from "vue";
import Vuex from "vuex";

import baleYardLots from "./modules/baleYardLots";
import billingDashboard from "./modules/billingDashboard";
import calendarUrls from "./modules/calendarUrls";
import clientFields from "./modules/clientFields";
import clients from "./modules/clients";
import commodities from "./modules/commodities";
import grindingLoads from "./modules/grindingLoads";
import lineItemSummaries from "./modules/lineItemSummaries";
import lineItems from "./modules/lineItems";
import lotUnits from "./modules/lotUnits";
import session from "./modules/session";
import templateWorkOrderLots from "./modules/templateWorkOrderLots";
import templateWorkOrderTaskLineItems from "./modules/templateWorkOrderTaskLineItems";
import templateWorkOrderTasks from "./modules/templateWorkOrderTasks";
import templateWorkOrders from "./modules/templateWorkOrders";
import users from "./modules/users";
import workOrderAttachments from "./modules/workOrderAttachments";
import workOrderInstructions from "./modules/workOrderInstructions";
import workOrderLots from "./modules/workOrderLots";
import workOrderNotes from "./modules/workOrderNotes";
import workOrderTaskLineItems from "./modules/workOrderTaskLineItems";
import workOrderTasks from "./modules/workOrderTasks";
import workOrders from "./modules/workOrders";

import inventoryLots from "./modules/inventoryLots";
import sellContracts from "./modules/sellContracts";
import trucks from "./modules/trucks";
import truckLoads from "./modules/truckLoads";

import truckLoadReports from "./modules/truckLoadReports";

import mNavigation from "./modules/mNavigation";

import commodityInventorySummaries from "./modules/commodityInventorySummaries";

Vue.use(Vuex);

export const enum StoreActions {
  loadInventoryLots = "loadInventoryLots",
  loadInventoryLot = "loadInventoryLot",

  loadSellContracts = "loadSellContracts",
  loadSellContract = "loadSellContract",

  loadTrucks = "loadTrucks",
  loadTruck = "loadTruck",

  loadTruckLoadReport = "loadTruckLoadReport",

  loadTruckLoads = "loadTruckLoads",
  loadTruckLoad = "loadTruckLoad",

  loadCommodityInventorySummaries = "loadCommodityInventorySummaries",
  loadCommodityInventorySummary = "loadCommodityInventorySummary",
}

export default new Vuex.Store({
  modules: {
    baleYardLots,
    billingDashboard,
    calendarUrls,
    clientFields,
    clients,
    commodities,
    grindingLoads,
    lineItemSummaries,
    lineItems,
    lotUnits,
    session,
    templateWorkOrderLots,
    templateWorkOrderTaskLineItems,
    templateWorkOrderTasks,
    templateWorkOrders,
    users,
    workOrderAttachments,
    workOrderInstructions,
    workOrderLots,
    workOrderNotes,
    workOrderTaskLineItems,
    workOrderTasks,
    workOrders,

    inventoryLots,
    sellContracts,
    trucks,
    truckLoads,
    truckLoadReports,

    commodityInventorySummaries,

    mNavigation,
  },
});
